import type * as React from 'react'

import { useIntl } from 'react-intl'
import { styled } from 'styled-components'

import { Spinner as BStockSpinner } from '@b-stock/fe-core/bstock-react'

const SpinnerPageContainer = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
`

type SpinnerProps = Omit<
  React.ComponentPropsWithoutRef<typeof BStockSpinner>,
  'text'
> & {
  text?: boolean
}

const Spinner = ({ text = true, ...props }: SpinnerProps) => {
  const { formatMessage } = useIntl()
  return (
    <BStockSpinner
      {...props}
      text={text ? formatMessage({ id: 'loading' }) : ''}
    />
  )
}

export default Spinner

export const SpinnerPage = () => (
  <SpinnerPageContainer>
    <Spinner />
  </SpinnerPageContainer>
)

/**
 * Spinner sized to fill the viewport, for blocking loads. Byte-identical copies
 * of this previously lived in PrivateRoute, FreightForwarderModal and
 * ResellerTaxModal.
 */
export const FullViewportSpinner = styled(Spinner)`
  width: 100%;
  height: 100vh;
  display: flex;
  align-content: center;
`

/**
 * Fixed translucent backdrop shown over page content while a blocking action
 * runs. PrivateRoute keeps its own copy of this at 0.9 alpha rather than 0.7 —
 * a real difference, so it is not shared.
 */
export const SpinnerOverlay = styled.div`
  position: fixed;
  z-index: 9999;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.7);
`
